import { useEffect, useState } from 'react';

/**
 * True on a phone-width screen. The same 768px the project workspace switches
 * to its phone tab bar at (ProjectWorkspace's .pw-tabbar), so the Punch List's
 * phone layout comes with the rest of the workspace's.
 */
export const PHONE_QUERY = '(max-width: 768px)';

export function usePhoneLayout(query = PHONE_QUERY): boolean {
  const read = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
  const [phone, setPhone] = useState(read);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const m = window.matchMedia(query);
    const on = () => setPhone(m.matches);
    on();
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, [query]);
  return phone;
}
